<template>
    <div class="country-wrapper">
        <div class="country-header">
            <span class="country-code">{{ country }}</span>
            <span :class="['flag-authority', 'flag-authority--'+ country.substr(0,2)]"></span>
        </div>
        <div class="country-name">{{ getCountryName(country) }}
            <span v-if="country === 'EP'" class="em">{{$t('symbol.bracket.before')}}*{{$t('symbol.bracket.after')}}</span>
        </div>
    </div>
</template>

<script>
import { get } from 'lodash';
import countryDb from 'library-@/config/country';

export default {
    name: 'Country',
    props: {
        country: {
            type: String,
            required: true,
        }
    },
    methods: {
        getCountryName(country) {
            return get(countryDb, `${country}.${this.$i18n.locale}`, country);
        },
    }
};
</script>

<style lang="scss">
.country-wrapper {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #061632;
    line-height: 20px;

    .country-header {
        display: flex;
        align-items: center;
        padding: 2px 0;

        .country-code {
            margin-right: 4px;
        }
    }

    .country-name {
        .em {
            display: inline-block;
            margin-left: 4px;
            color: red;
        }
    }
}
</style>
